/**
 * Where should the field be collected
 *
 * This is used as a hint to field collectors to stop them collecting
 * data in the field when its best collected in the back office.
 */
export const IkeCollectorType = {
	/**
	 * No preference on where to be collected.
	 * @default
	 */
	ALL: 'all' as const,
	/** Prefer to be collected in the field */
	FIELD: 'field' as const,
	/** Prefer to be collected in the office */
	OFFICE: 'office' as const,
};

export type IkeCollectorType =
	| typeof IkeCollectorType.ALL
	| typeof IkeCollectorType.FIELD
	| typeof IkeCollectorType.OFFICE;
